import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Es un libro físico?',
  answer: 'No, es un producto digital de descarga inmediata. Recibirás la guía PDF, el audiolibro y la tarjeta S.O.S directamente en tu correo electrónico para que puedas acceder desde cualquier dispositivo.'
}, {
  question: '¿Funciona si mi ansiedad es muy fuerte?',
  answer: 'Sí, el protocolo está diseñado para actuar sobre la respuesta física del cuerpo, sin importar qué tan fuerte sea la emoción. Al trabajar directamente con el nervio vago, bypasea la mente racional y actúa sobre tu sistema nervioso.'
}, {
  question: '¿Cómo recibo los audios?',
  answer: 'Recibirás un archivo ZIP con los 5 tracks listos para reproducir en cualquier dispositivo. También puedes escucharlos directamente desde tu celular o computadora.'
}, {
  question: '¿Es seguro?',
  answer: 'Completamente. El Protocolo Cortisol-Zero se basa en técnicas de estimulación vagal respaldadas por estudios científicos. No requiere medicación, no es invasivo ni tiene efectos secundarios.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tienes nuestra garantía de satisfacción. Si pruebas el protocolo y no sientes mejoría, te devolvemos tu dinero sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-brown" data-id="element-45">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-white border-sage' : 'bg-white/50 border-sage-light hover:border-sage/50'}`} data-id="element-47">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-48">
                  <span className="font-heading font-semibold text-lg text-brown pr-4" data-id="element-49">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-sage-dark transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" />
                </button>

                <AnimatePresence initial={false} data-id="element-51">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-52">
                      <div className="px-6 pb-5 text-brown-light leading-relaxed" data-id="element-53">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}